import React from 'react'
import Subheader from '../../component/Subheader'
import HaldiHead from '../Haldi/HaldiHead';
import HaldiImage from '../Haldi/HaldiImage';
import HaldiBook from '../Haldi/HaldiBook';
import HaldiGallery from '../Haldi/HaldiGallery';
import HaldiCraft from '../Haldi/HaldiCraft';
import HaldiInstagram from '../Haldi/HaldiInstagram';
import HaldiLogoslider from '../Haldi/HaldiLogoslider';
import HaldiService from '../Haldi/HaldiService';

export default function Contemporary() {
    const subheadData = {
      image: '../image/contemporary-banner.webp',
      heading: 'Contemporary Couture Rooted in Indian Heritage',
      pagename: 'Contemporary',
    }


    const headdata = {
        title: "Where Heritage Meets Modern Elegance",
        heading: "The Art of Contemporary Indian Fashion",
        description:"At Sonam Label, contemporary fashion is reimagined through refined silhouettes, intricate craftsmanship, and a modern design language inspired by Indian artistry. Each ensemble combines subtle embellishments, fluid structures, and timeless hues tailored for today’s confident woman. Designed for comfort, versatility, and expressive style, our Contemporary Edit allows you to celebrate individuality with effortless elegance, making every moment feel intentional, personal, and beautifully crafted.",
        buttonText: "Learn More",
        link: "/contact",
    };


    const haldiimage = [
        { src: "../image/contemporary-img-1.webp", alt: "Contemporary" },
        { src: "../image/contemporary-img-2.webp", alt: "Contemporary" },
        { src: "../image/contemporary-img-3.webp", alt: "Contemporary" },
    ];


    const haldiService = {
      tagline: "Contemporary Collection",
      heading: "The New Age of Effortless Elegance",
      image: "/image/contemporary-service.webp",
      accordions: [
        {
          title: "Modern Glamour, Redefined",
          description:"Every outfit reflects meticulous craftsmanship, featuring hand embroidery, metallic accents, and layered textures, creating a youthful, expressive, and distinctly Sonam aesthetic."
        },
        {
          title: "Artful Embroidery & Luxe Textures",
          description:"From intricate threadwork to thoughtfully layered fabrics, each piece is designed to embody sophistication, style, and individuality while celebrating heritage."
        },
        {
          title: "Effortlessly Statement-Making",
          description:"Our ensembles make an understated yet striking impression, balancing contemporary silhouettes with artisanal detailing to create versatile, memorable looks."
        },
        {
          title: "Designed for Celebrations & Beyond",
          description:"Perfect for weddings, soirées, or festive occasions, every creation is made for ease of movement, comfort, and confident expression."
        },
        {
          title: "The Sonam Signature",
          description:"Distinctive craftsmanship, innovative design, and cultural depth define the Sonam aesthetic, allowing every piece to resonate with elegance and modernity."
        },
      ]
    };


    const haldigallery = [
        { src: "../image/contempgallery-1.webp"},
        { src: "../image/contempgallery-2.webp"},
        { src: "../image/contempgallery-3.webp"},
        { src: "../image/contempgallery-4.webp"},
        { src: "../image/contempgallery-5.webp"},
    ];


    const haldiCraft = {
      heading: "Where Fresh Design Finds Its Rhythm",
      description:"Sonam Label’s contemporary edit redefines modern Indian fashion with fluid silhouettes, subtle textures, and thoughtfully crafted details. Tailored for today’s woman who values elegance, individuality, and refined simplicity, each piece enables confident movement, effortless style, and expressive sophistication."
    };


    const haldiInsta = [
      {image: "/image/contempinsta-1.webp"},
      {image: "/image/contempinsta-2.webp"},
      {image: "/image/contempinsta-3.webp"},
      {image: "/image/contempinsta-4.webp"},
      {image: "/image/contempinsta-5.webp"},
    ];

  return (
    <>
    <Subheader subheadData={subheadData}/>
    <HaldiHead headdata={headdata}/>
    <HaldiImage haldiimage={haldiimage}/>
    <HaldiLogoslider/>
    <HaldiService haldiService={haldiService}/>
    <HaldiBook/>
    <HaldiGallery haldigallery={haldigallery}/>
    <HaldiCraft haldiCraft={haldiCraft}/>
    <HaldiInstagram haldiInsta={haldiInsta}/>
    </>
  )
}
